import { HomeSupplementaryMaterialsTable } from './HomeSupplementaryMaterialsTable';
export default HomeSupplementaryMaterialsTable;
